import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'utils/axios';

const queryKeyCertificate = 'certificate';

const fetchUnclaimCertificates = async () => {
  const { data } = await axiosInstance.get(`v2/certificate/unclaimed`, {
    params: {
      type: 'free course',
    },
  });
  return data?.data;
};

const useGetCertificate = () => {
  return useQuery({
    queryKey: [queryKeyCertificate],
    queryFn: () => fetchUnclaimCertificates(),
  });
};

export { useGetCertificate, fetchUnclaimCertificates };
